#import "../fragments/product-fragment.graphql"

mutation CreateProduct($input: ProductCreateInput!) {
    productCreate(input: $input) {
        product {
            ...ProductFragment
        }
    }
}
